<template>
      <b-col sm="12" md="12" lg="12" xl="12">
        <b-form-group
          label="Nome do Circulante"
          label-for="nomeCirculante"
          label-class="float-left"
        >
          <info-icon
            v-b-tooltip.hover.right="
              'Informe o nome do circulante'
            "
            class="tooltip-icon"
          />
          <b-form-input
            name="nomeCirculante"
            v-model="nome_circulante"
            @input="(v) => $emit('updateModel', { nome_circulante: v })"
            class="invision-input input-icon"
            :disabled="isBusy"
            v-validate="{ required: true, min: 3 }"
            :state="validateState('nomeCirculante')"
          ></b-form-input>
        </b-form-group>
      </b-col>
</template>

<script>
export default {
  name: 'NomeCirculante',
  inject: ['validator', 'validateState'],
  created() {
    this.$validator = this.validator;
  },

  data() {
    return {
      nome_circulante: '',
    };
  },

  props: {
    isBusy: {
      type: Boolean,
    },
    options: {
      type: Object,
      required: false,
    },
  },
};
</script>
